import {ENDPOINT_ADMIN_EXCHANGE_RATES_LIST} from "../../constants/api";

const CancelablePromise = require('mn-utils/CancelablePromise');
const loopMap = require('mn-utils/loopMap');
const {
  apiRequestAdmin,
} = require('../ws');


const MOCK_EXCHANGE_RATES = loopMap(100, (i) => {
  const id = '' + (1 + i);
  return {
    base: 'BTC _ ' + id,
    quote: 'USDT _ ' + id,
    updated_at: '2021-03-05T14:00',
    exchange_type: 'binance',
    exchange_name: 'binance',
    rate: '49163.86000000',
  };
});

export function apiAdminExchangeRatesList(params) {
  params = params || {};
  const offset = params.offset || 0;
  const limit = params.limit || 50;
  if (process.env.MOCK) {
    return CancelablePromise.delay(500, {
      list: MOCK_EXCHANGE_RATES.slice(offset, offset + limit),
      count: MOCK_EXCHANGE_RATES.length,
    });
  }
  return apiRequestAdmin(ENDPOINT_ADMIN_EXCHANGE_RATES_LIST, {
    ...params,
    offset,
    limit,
  });
}
